module.exports = __webpack_public_path__ + "static/peak-5c66e4bf1d4674952bd752ddbde74810.jpg";